import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ExitoGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const parametro = route.queryParams?.p || route.queryParams?.p_webpay;

    if (!parametro) {
      this.router.navigateByUrl('/datos-generales');
      return false;
    }

    return true;
  }
}
